export const LICENCA_STATUS_LABELS = {
  1: 'Aguardando abertura',
  2: 'Processo aberto',
  3: 'Licença emitida',
  4: 'Solicitada prorrogação',
  5: 'Finalizado',
  6: 'Suspensa',
  7: 'Cassada',
};

/** Espelha LICENCA_TRANSITIONS do api-gateway. */
export const LICENCA_TRANSITIONS = {
  1: ['2'],
  2: ['3', '4', '5'],
  3: ['4', '5', '6', '7'],
  4: ['2', '3', '5', '6', '7'],
  5: [],
  6: ['3', '7'],
  7: [],
};

export function licencaStatusChoices(current, { creating = false } = {}) {
  if (creating) {
    return Object.entries(LICENCA_STATUS_LABELS);
  }
  const cur = String(current || '1');
  const next = LICENCA_TRANSITIONS[cur] || [];
  const ids = [cur, ...next.filter((id) => id !== cur)];
  return ids.map((id) => [id, LICENCA_STATUS_LABELS[id] || id]);
}
